export const formatPhoneCode = (code: string) => {
  return code.startsWith('+') ? code : `+${code}`;
};
